import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldCheck } from 'lucide-react';

/** Entry card shown ONLY when the collaborator has pending designated-evaluator tasks. */
export default function MeEvaluatorTasksCard() {
  const { i18n } = useTranslation();
  const es = (i18n.language || '').startsWith('es');
  const navigate = useNavigate();
  const [pending, setPending] = useState(0);
  useEffect(() => {
    api.get('/evaluator/workspace')
      .then((r) => setPending((r.data.tasks || []).filter((x) => !x.submitted && x.authorized).length))
      .catch(() => setPending(0));
  }, []);
  if (!pending) return null;
  return (
    <Card className="p-4 flex items-center gap-3 border-primary/30" data-testid="me-evaluator-tasks-card">
      <ShieldCheck className="h-5 w-5 text-primary shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-medium text-sm">{es ? 'Evaluaciones asignadas' : 'Assigned evaluations'}</p>
        <p className="text-xs text-muted-foreground">
          {es ? `Tienes ${pending} observación(es) de competencias pendiente(s).`
              : `You have ${pending} pending competency observation(s).`}
        </p>
      </div>
      <Button size="sm" onClick={() => navigate('/me/evaluations')} data-testid="me-evaluator-tasks-open">
        {es ? 'Evaluar' : 'Evaluate'}
      </Button>
    </Card>
  );
}
